import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class EnumTitlesService {
    constructor(private translate: TranslateService) {}

    getEnumTitle(namespace: string, value: string): string {
        const key = `${namespace}.${value}`;
        return this.translate.instant(key);
    }
}
